jQuery(document).ready(function ($) {

    $('.ingredients').select2({
        placeholder: "Click here"
    });



    /**
     * upgrade this later. Maybe.
    $('.ingredients').on('select2:select', function (e) {
        var data = $('.ingredients').select2('data');
        var params = [];
        $(data).each( function(index, item) {
            params.push(item.id);
        });

    });
     **/

});
